import { Component } from '@angular/core';

@Component({
    templateUrl: 'unauthorized.component.html'
})

export class UnauthorizedComponent {
    constructor() { }
}


// WEBPACK FOOTER //
// ./src/app/core/unauthorized.component.ts